import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as usertypes from '@account/store/types';

// component
import SearchForm from '@home/components/Search/SearchForm.vue'
import SearchResultBoard from '@home/components/Search/SearchResultBoard.vue'
import SearchResultOrg from '@home/components/Search/SearchResultOrg.vue'
import { createEventBus } from '@/modules/@appbase/util';
import api from "@gnb/api";

@Component({
    components: {
        SearchForm,
        SearchResultBoard,
        SearchResultOrg
    },
    computed: mapGetters({
        userCurrent: usertypes.CURRENT
    })
})
export default class SearchContainer extends Vue {
    @Prop({type:Boolean}) useSearchSystem!: boolean

    userCurrent!: account.TCurrent;
    searchText: string = ''
    searchBaseUrl : string = ""

    ifrmSearch: HTMLIFrameElement | null= null;
   
    // DB검색용 화면 데이터
    currentPage: number = 1
    pageSize: number = 6
    articleList: gnbarticle.Article[] = []
    articleCount: number = 0
    userLang: string = ''

    created(){          
        createEventBus(window, 'portal-goBoardDetail', this.boardDetailHandler);
        
        this.userLang = this.userCurrent.userConfig.language
        let reqSearch = (this.$route.query.searchText ? this.$route.query.searchText.toString() : '')        
        this.searchText = reqSearch;
        this.searchBaseUrl = `${window.location.origin}/srch`
        
        if(!this.useSearchSystem) this.fnTotalSearch(this.searchText)
    }  

    fnTotalSearch(text: string) {
       this.searchText = text;

        // 게시판 데이터 검색
        if (!this.useSearchSystem){
            this.fnSearchArticle(this.currentPage, this.pageSize)
        }
    }
    
    // 게시글 검색
    fnSearchArticle(pageNum: number, pageSize: number){
        this.currentPage = pageNum;
        this.pageSize = pageSize

        // 게시판 데이터 검색(DB)
        if(!this.useSearchSystem){
            api.gnb.searchArticles(this.searchText,this.currentPage,this.pageSize = pageSize)
            .then(res=>{
                if (res){
                    this.articleList = res.data;
                    this.articleCount = res.totalCount;
                }
            });
        }
    }

    boardDetailHandler(data: { boardId: number, articleId: number, volumeName: string }) {
        this.$router.push({
            path: 'modal/read',
            append: true,
            query: {
                SYSID: data.boardId.toString(),
                ARTICLEID: data.articleId.toString()           
            }
        })
    }

}